import React, {Component} from 'react'
import FormatMessage from "../messages/FormatMessage";
import {withRouter} from 'react-router-dom';

const homePageLink = process.env.REACT_APP_EQ_HEADER_BASE_URL;

class EQHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className="SiteHeader">
            <div className="FixedLayout SiteHeader-layout">
                <div className="FixedLayoutAside SiteHeader-aside">
                    <div className="SiteHeader-logoContainer">
                        <div className="SiteHeader-logoLarge">
                            <a href={homePageLink} className="SiteLogo">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                        <div className="SiteHeader-logoInBetween">
                            <a href={homePageLink} className="SiteLogo SiteLogo-medium">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                        <div className="SiteHeader-logoSmall">
                            <a href={homePageLink} className="SiteLogo SiteLogo-small">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="FixedLayoutMain SiteHeader-main">
                    <div className="SiteHeader-mainOpened">
                        <div className="SiteHeader-userBar">
                            <div className="SiteHeader-userBarItem">
                                <FormatMessage id="application.signin.link">
                                    {(message) => !message.toString().includes("application.signin.link") ?
                                        <a className="SiteHeader-userBarLink"
                                           href="/application-center/applicationcenter.do">
                                            {message}
                                        </a>
                                        : ""}
                                </FormatMessage>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default withRouter(EQHeader)